import React, {useCallback, useEffect} from 'react';
import {Grid, makeStyles, Tooltip} from '@material-ui/core';
import {observer} from 'mobx-react-lite';
import {Parameter} from '@/Core/mobx/ParameterStore/Parameter';
import {Approval} from '@/Core/mobx/ParameterStore/Approval';
import {CategoryCard} from '../PreApprovals/CategoryCard';
import {TextBox} from '@/Core/UI';
import {SelectInputElement} from '../PreQualification/Components/SelectInputElement';
import {fieldOptions} from '@/Core/mobx/ParameterStore/PrequalXref';

type BasicInfoProps = {
    valueChanged: (p?: Parameter & {name?: string}, value?: any, name?: string) => void;
    parameters: Approval;
    setCategory: (entry: string) => void;
    index: number;
    setCompleted?: (completed: boolean) => void;
};

const BasicInfo = observer(({valueChanged, parameters, setCategory, index, setCompleted}: BasicInfoProps) => {
    const required = (value?: string) => (
        <span>
            {value && value} <span style={{color: 'red'}}>*</span>
        </span>
    );

    useEffect(() => {
        if (setCompleted) {
            setCompleted(
                parameters.address?.value !== '' &&
                    parameters.addressCity?.value !== '' &&
                    parameters.state?.value !== '' &&
                    parameters.addressZipCode?.value !== '',
            );
        }
    }, [
        setCompleted,
        parameters.address?.value,
        parameters.addressCity?.value,
        parameters.state?.value,
        parameters.addressZipCode?.value,
    ]);

    return (
        <CategoryCard title={'Basic Information'} setCategory={setCategory} index={index}>
            <Grid item xs={4}>
                <TextBox
                    id={'address'}
                    label={required('Street Address')}
                    value={parameters.address?.value}
                    onChange={(value) => valueChanged(parameters.address, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id={'addressCity'}
                    label={required('City')}
                    value={parameters.addressCity?.value}
                    onChange={(value) => valueChanged(parameters.addressCity, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'State',
                        options: fieldOptions.state.options,
                        ...parameters.state,
                        name: 'state',
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={2}>
                <TextBox
                    id={'addressZipCode'}
                    label={required('Zipcode')}
                    value={parameters.addressZipCode?.value}
                    onChange={(value) => valueChanged(parameters.addressZipCode, value)}
                />
            </Grid>
        </CategoryCard>
    );
});

export default BasicInfo;
